window.addEventListener('DOMContentLoaded', () => {
  const stickyATC = document.querySelector('#lumin-sticky-atc');
  if (!stickyATC) return;

  // Desktop: sticky bar is CSS-hidden; skip scroll listeners to avoid layout padding
  const desktopMq = window.matchMedia('(min-width: 990px)');
  if (desktopMq.matches) return;

  const mainAddBtn = document.querySelector('.product-form button[name="add"], button[name="add"]');
  if (!mainAddBtn) return;

  const selectField = stickyATC.querySelector('select[name="id"]');
  const img = stickyATC.querySelector('.product-content img');
  const threshold =
    mainAddBtn.getBoundingClientRect().bottom + window.scrollY + Number(stickyATC.dataset.offset || 0);

  const syncPadding = (visible) => {
    document.documentElement.style.paddingBottom = visible ? `${stickyATC.clientHeight}px` : '0';
    document.documentElement.style.height = 'auto';
  };

  window.addEventListener(
    'scroll',
    () => {
      if (window.scrollY > threshold) {
        stickyATC.classList.add('show');
        syncPadding(true);
      } else {
        stickyATC.classList.remove('show');
        syncPadding(false);
      }
    },
    { passive: true }
  );

  if (selectField) {
    selectField.addEventListener('change', () => {
      const option = selectField.options[selectField.selectedIndex];
      if (img && option?.dataset?.img) {
        img.setAttribute('src', option.dataset.img);
      }
    });
  }

  document.querySelector('.product-form [name="id"]')?.addEventListener('change', (e) => {
    const value = Number(e.target.value);
    if (value && selectField) {
      selectField.value = value;
    }
  });
});
